<template>
    <nav-tabs
        :exact="false"
        :tabs="[
            { label: 'Mozart', route: 'auditoria.mozart' },
        ]"
    />
    <router-view></router-view>
</template>

<script>
    import NavTabs from "../../components/layouts/NavTabs.vue";

    export default {
        components: { NavTabs },

        mounted() {
            if (this.$route.name === 'auditoria') {
                this.$router.push({ name: 'auditoria.mozart' });
            }
        }
    }
</script>
